/// \file adminRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Route } from "react-router-dom";
import customerRoutes from './customersRoutes'
import equipmentMakesRoutes from './equipmentMakesRoutes'
import equipmentModelsRoutes from './equipmentModelsRoutes'
import assetManagementRoutes from './assetManagementRoutes';
import newAssetType from "./assetTypeRoutes";
import assetGroupRoutes from './assetGroupRoutes';
import notificationSubscription from './notificationSubscriptions';
import adminNotifications from './adminNotifications';
import maintenancePlans from "./maintenancePlans";
import aemp from "./aemp";
import siteManagement from "./siteManagement";
import alertsManagement from "./alertsManagement";
import setSystemNotifications from "./setSystemNotifications";
const routes = (
  <Route
    path="admin"
    handle={{
      text: 'Admin'
    }}
    >
    {customerRoutes}
    {equipmentMakesRoutes}
    {equipmentModelsRoutes}
    {assetManagementRoutes}
    {assetGroupRoutes}
    {newAssetType}
    {notificationSubscription}
    {adminNotifications}
    {maintenancePlans}
    {aemp}
    {siteManagement}
    {alertsManagement}
    {setSystemNotifications}
  </Route>
);

export default routes;